<template>
  <div>
    <div class="d-flex flex-wrap gap-3 mb-3">
      <v-btn outlined color="success" @click="addData">Tambah Varian</v-btn>
      <v-menu offset-y v-if="selected.length">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="ml-3" v-bind="attrs" v-on="on" color="primary">
            Action
            <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="removeData">
            <v-list-item-title>Delete</v-list-item-title>
          </v-list-item>
          <v-list-item @click="dialog = true">
            <v-list-item-title>Terapkan Data Varian</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <v-card>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th></th>
              <th
                v-for="header in headers"
                :key="header.value"
                class="text-left"
              >
                {{  Object.keys(discountVariantMemberType).includes(header.value) ? 'Diskon '+header.text : header.text }}
              </th>
            </tr>
          </thead>
          <tbody v-if="varian_arr.length">
            <tr v-for="(item, index) in varian_arr" :key="index">
              <td>
                <v-checkbox
                  :value="selected.includes(index)"
                  @click="toggle(index)"
                ></v-checkbox>
              </td>
              <td v-for="(header) in headers" :key="header.value">
                <template v-if="header.value == 'varian_image'">
                  <imageUpload
                    class="py-3"
                    v-model="item.varian_images"
                    width="100"
                  />
                </template>
                <template
                  v-else-if="
                    ['varian_name', 'varian_code'].includes(header.value)
                  "
                >
                  <v-text-field
                    v-model="item[header.value]"
                    dense
                    :rules="header.value == 'varian_name' ? required : []"
                  ></v-text-field>
                </template>
                <template
                  v-else-if="
                    [
                      'varian_price',
                      'varian_stock_quantity',
                      'varian_weight',
                      ...Object.keys(discountVariantMemberType),
                    ].includes(header.value)
                  "
                >
                  <v-currency-field
                    v-model="item[header.value]"
                    class="py-1"
                    :prefix=" [
                      'varian_price',
                      ...Object.keys(discountVariantMemberType),
                    ].includes(header.value) ? 'Rp ' : ''"
                    single-line  @change="
                      $emit('checkVariantDiscount', {
                        index,
                        key: header.value,
                      })
                    "
                    :rules="required"
                    hide-details="auto"
                  ></v-currency-field> 
                  <small v-if="Object.keys(discountVariantMemberType).includes(header.value)">
                    HJ: {{ calculateDiscount(item,header.value) }}
                  </small>
                </template>
                <template v-else-if="header.value === 'varian_status'">
                  <v-switch
                    v-model="item[header.value]"
                    hide-details="auto"
                    true-value="active"
                    false-value="inactive" 
                  ></v-switch>
                </template>
                <template v-else>{{ header.value }}</template>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td :colspan="headers.length + 1" class="text-center">No Data</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Terapkan Data</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="formApply">
              <v-text-field
                v-model="formApply.varian_price"
                label="Harga"
              ></v-text-field>
              <v-text-field
                v-model="formApply.varian_stock_quantity"
                label="Stok"
              ></v-text-field>
              <v-text-field
                v-model="formApply.varian_code"
                label="SKU"
              ></v-text-field>
              <v-text-field
                v-model="formApply.varian_weight"
                label="Berat"
              ></v-text-field>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn color="blue darken-1" text @click="applyData"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import imageUploadVue from "@/components/imageUpload.vue";
import { mapState } from "vuex";
const defaultVarianArr = () => ({
  varian_name: "-",
  varian_price: "0",
  varian_stock_quantity: "0",
  varian_weight: "0",
  varian_code: "",
  varian_status: "active",
  is_main: "0",
  varian_image: "",
});
export default {
  components: {
    imageUpload: imageUploadVue,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    isDiscountMemberEnable: {
      type: [Number,String],
    },
    isDicountMemberPercent: {
      type: [Number,String],
    },
  },
  data() {
    return {
      selectAll: false,
      required: [(v) => !!v || "Harus diisi"],
      header: [
        { text: "Gambar", sortable: false, value: "varian_image" },
        { text: "Nama", sortable: false, value: "varian_name" },
        { text: "Harga", sortable: false, value: "varian_price" },
        { text: "Stok", sortable: false, value: "varian_stock_quantity" },
        { text: "SKU", value: "varian_code", sortable: false },
        { text: "Berat (Gram)", value: "varian_weight", sortable: false },
        { text: "Status", value: "varian_status", sortable: false },
      ],
      dialog: false,
      selected: [],
      formApply: {
        varian_price: "",
        varian_stock_quantity: "",
        varian_code: "",
        varian_weight: "",
      },
      loading: false,
      items: [],
    };
  },
  computed: {
    varian_arr: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    ...mapState("options", ["memberType"]),
    headers() {
      let memberType = this.memberType.map((item) => {
        return {
          text: item.label,
          value: "varian_discount_nominal_" + item.value,
          sortable: false,
          hidden: this.isDiscountMemberEnable == '0' || this.isDicountMemberPercent == '1'
        };
      });
      return [...this.header, ...memberType.filter(item => item.hidden == false)];
    },
    discountVariantMemberType() {
      return this.memberType.reduce((acc, item) => {
        acc["varian_discount_nominal_" + item.value] = 0;
        return acc;
      }, {});
    },
  },
  methods: { 
    calculateDiscount(item, key) {
      let valueDiscount = Number(item[key])
      let price = Number(item.varian_price)
      if(!price) return 0
      return (price - valueDiscount).toLocaleString("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0
      }) 
    },
    toggleAll() {
      this.selected =
        this.selected.length === this.varian_arr.length ? [] : this.varian_arr;
    },
    toggle(index) {
      if (this.selected.includes(index))
        this.selected = this.selected.filter((item) => item !== index);
      else this.selected.push(index);
    },
    removeData() {
      this.$emit("removedata", this.selected);
      setTimeout(() => {
        this.selected = [];
      }, 300);
    },
    addData() {
      // const index = this.varian_arr.length;
      this.varian_arr.push({
        ...defaultVarianArr(),
        ...this.discountVariantMemberType,
      });
    },
    applyData() {
      const valid = this.$refs.formApply.validate();
      if (valid) {
        this.dialog = false;
        this.$emit("updateData", {
          indexes: this.selected,
          formApply: this.formApply,
        });
        this.dialog = false;
        this.formApply = {
          varian_price: "",
          varian_stock_quantity: "",
          varian_code: "",
          varian_weight: "",
        };
        this.$refs.formApply.resetValidation();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>